import { CommunicationDataBaseTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { CommunicationDataBaseType } from '@/services/graphql/types';

export const mapperCommunicationDataBaseTypeDataEnum = createEnumMapperFunction(
  CommunicationDataBaseType,
  CommunicationDataBaseTypeDataEnum
);
